import React,{ Fragment, Component} from 'react';
import {Link} from 'react-router-dom';
import WOW from 'wowjs';
import Header from './../Layout/Header';
import FooterPremium from './../Layout/FooterPremium';
import PageTitle from './../Layout/PageTitle';
import ExhibitionSlider1 from './../Element/ExhibitionSlider1';
import ExhibitionSlider2 from './../Element/ExhibitionSlider2';

//images/

class CompanyExhibition extends Component{
	componentDidMount(){
		new WOW.WOW().init();	
	}
	render(){
		return(
			<Fragment>
				<Header />
				<div className="page-content bg-white">
					<PageTitle motherMenu="Company Exhibition" activeMenu="Company Exhibition" />
					{/*  Inner Page Banner */}
					<section className="content-inner exhibition-bx" data-content="EXHIBITION">
						<ExhibitionSection />
					</section>
					<div className="section-full">
						<ExhibitionSlider2 />
					</div>
				</div>
				<FooterPremium />
			</Fragment>
		)	
	}
}

function ExhibitionSection(){
	return(
		<>
			<div className="container">
				<div className="row align-items-center">
					<div className="col-lg-6 ">
						<ExhibitionSlider1 />
					</div>
					<div className="col-lg-6 m-b30">
						<div className="section-head">
							<h2 className="title">Goldcrest Dreams, </h2>
							<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
								<li>Goldcrest Dreams, Ajman features 1 and 2-bedroom apartments in each of its five stories.</li>
								<li>Every unit includes a balcony.</li>
								<li>Each apartment has an open kitchen, tiled baths, and built-in wardrobes in the bedrooms.</li>
								<li>Glass doors connect the bedrooms and living areas to the balcony.</li>
								<li>The kitchen features wood cabinets and stone worktops.</li>
								<li>Also included in the kitchen are a sink, a working hood, and enough room for a cooking range.</li>
							</ul>
							
						</div>
						{/* <Link to={"/contact-us-1"} className="btn btn-primary m-r10 m-b10">Contact us</Link>
						<Link to={"/portfolio-1"} className="btn btn-primary m-b10">View Portfolio</Link> */}
					</div>
				</div>
			</div>
		</>
	)
}
export {ExhibitionSection};

export default CompanyExhibition;